import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState('customer', ['cdata']),
  },

  //- '_trackPageview' gets fired from GTM on each page load, however
  //- Single Page App sections of our site need to call this function on each route change.
  //- Only needed if the Vue page has more than one route. For example Color Advisor is a
  //- Vue page but it does not have multiple Vue routes and does not need this mixin.

  //- Do not fire this when agent has logged in to customers account
  watch:{
    '$route': {
      handler() {
        if (window._sift && !this.cdata.agentImpostor) {
          window._sift.push(['_trackPageview']);
        }
      }
    }
  },
};